// extracted by mini-css-extract-plugin
var _1 = "ReleaseFlag--YIDKTHie";
var _2 = "orgContainer--KCRgDwE6";
var _3 = "orgItem--wOyb1Prd";
var _4 = "orgItemsLink--NoFhpL4B";
var _5 = "outerContainer--H2leYOyp";
var _6 = "panel--JYSXZWTu";
var _7 = "title--m2uHYAHV";
export { _1 as "ReleaseFlag", _2 as "orgContainer", _3 as "orgItem", _4 as "orgItemsLink", _5 as "outerContainer", _6 as "panel", _7 as "title" }
